const t = {
  withSpace: {
    type: Boolean,
    default: !0
  },
  withSpaceTop: {
    type: Boolean,
    default: !0
  },
  withSpaceBottom: {
    type: Boolean,
    default: !0
  },
  spaceOptionsSmall: {
    type: Object,
    default: () => ({
      top: !0,
      bottom: !0
    })
  },
  spaceOptionsMedium: {
    type: Object,
    default: () => ({
      top: !0,
      bottom: !0
    })
  },
  fullScreen: {
    type: Boolean,
    default: !1
  }
};
export {
  t as sectionProps
};
